import { createAction, props } from '@ngrx/store';
import { DataResult } from '@progress/kendo-data-query';
import { IntegrationMapping } from '../../models/integration-mapping.model';
import { IntegrationLookup } from '../../models/integration-lookup.model';
import { HttpResponseStatus, IntegrationMappingResponse } from './integration-mappings.reducer';
import { FetchArgs } from 'src/app/shared/models/core';

export enum IntegrationMappingsActionsEnum {
    GetAllIntegrationMappings = '[INTEGRATIONS MAPPINGS] Get all Integration Mappings',
    SetAllIntegrationMappings = '[INTEGRATIONS MAPPINGS] Set all Integration Mappings',
    GetIntegrationMappingsLookup = '[INTEGRATIONS MAPPINGS] Get all Integration Mappings Lookup and Mappings',
    SetAllIntegrationMappingsLookup = '[INTEGRATIONS MAPPINGS] Set all Integration Mappings Lookup and Mappings',
    AddIntegrationMapping = '[INTEGRATIONS MAPPINGS DETAILS] Add new  Integration Mappings ',
    UpdateIntegrationMapping = '[INTEGRATIONS MAPPINGS DETAILS] Update new  Integration Mappings ',
    DeleteIntegrationMapping = '[INTEGRATIONS MAPPINGS DETAILS] Delete new  Integration Mappings ',
    SetIsSaving = '[INTEGRATIONS MAPPINGS DETAILS] Set Is saving ',
    SetCrudResponse = '[INTEGRATIONS MAPPINGS DETAILS] Set Response After Crud event',
    SetStatus = '[INTEGRATIONS MAPPINGS DETAILS] Set status'
}

export const getAllIntegrationMappings = createAction(
    IntegrationMappingsActionsEnum.GetAllIntegrationMappings,
    props<{ args: FetchArgs }>()
);

export const setAllIntegrationMappings = createAction(
    IntegrationMappingsActionsEnum.SetAllIntegrationMappings,
    props<{ integrationMappingsList: DataResult }>()
);

export const getIntegrationMappingsLookup = createAction(IntegrationMappingsActionsEnum.GetIntegrationMappingsLookup);

export const setIntegrationMappingsLookup = createAction(
    IntegrationMappingsActionsEnum.SetAllIntegrationMappingsLookup,
    props<{ integrationMappingsLookup: IntegrationLookup; integrationMappingsList: DataResult }>()
);

export const addIntegrationMapping = createAction(
    IntegrationMappingsActionsEnum.AddIntegrationMapping,
    props<{ integration: IntegrationMapping }>()
);

export const updateIntegrationMapping = createAction(
    IntegrationMappingsActionsEnum.UpdateIntegrationMapping,
    props<{ integration: IntegrationMapping }>()
);

export const deleteIntegrationMapping = createAction(
    IntegrationMappingsActionsEnum.DeleteIntegrationMapping,
    props<{ id: number }>()
);

export const setIsSaving = createAction(IntegrationMappingsActionsEnum.SetIsSaving, props<{ isSaving: boolean }>());

export const setCrudResponse = createAction(
    IntegrationMappingsActionsEnum.SetCrudResponse,
    props<{ response: IntegrationMappingResponse }>()
);

export const setStatus = createAction(
    IntegrationMappingsActionsEnum.SetStatus,
    props<{ status: HttpResponseStatus }>()
);

export const IntegrationMappingsActions = {
    getAllIntegrationMappings,
    setAllIntegrationMappings,
    getIntegrationMappingsLookup,
    setIntegrationMappingsLookup,
    addIntegrationMapping,
    updateIntegrationMapping,
    deleteIntegrationMapping,
    setIsSaving,
    setCrudResponse,
    setStatus
};
